import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/of';
import { LocalStorageService } from 'ngx-webstorage';

@Injectable()
export class AddressValidationService {

  private smartyStreetRequestUrl = 'https://us-street.api.smartystreets.com/street-address?';
  private smartyStreetZipCodeUrl = 'https://us-zipcode.api.smartystreets.com/lookup?';
  private smartyStreetAutocompleteUrl = 'https://us-autocomplete.api.smartystreets.com/suggest?';
  private smartyStreetAutocompleteProUrl = 'https://us-autocomplete-pro.api.smartystreets.com/lookup?';
  private smartyStreetKeys = 'key=' + this.localSt.retrieve('smartyStreetKey');
  private smartyStreetKeysPro = 'key=' + this.localSt.retrieve('smartyStreetKey');

  constructor(
    private http: HttpClient,
    private localSt: LocalStorageService
  ) { }

  addressValidate(data): Observable<any> {
    let params = this.smartyStreetKeys;
    if (data.address_line_1) {
      params += `&street=` + encodeURIComponent(data.address_line_1);
    }
    if (data.address_line_2) {
      params += `&street2=` + encodeURIComponent(data.address_line_2);
    }
    if (data.state) {
      params += `&state=` + encodeURIComponent(data.state);
    }
    if (data.city) {
      params += `&city=` + encodeURIComponent(data.city);
    }
    if (data.zip_code) {
      params += `&zipcode=${data.zip_code}`;
    }
    return this.http.get(this.smartyStreetRequestUrl + params);
  }

  zipCodeValidate(data): Observable<any> {
    let params = this.smartyStreetKeys;
    if (data.city) {
      params += `&city=` + encodeURIComponent(data.city);
    }
    if (data.state) {
      params += `&state=` + encodeURIComponent(data.state);
    }
    if (data.zip_code) {
      params += `&zipcode=${data.zip_code}`;
    }
    return this.http.get(this.smartyStreetZipCodeUrl + params);
  }

  autocomplete(data): Observable<any> {
    let params = this.smartyStreetKeys;
    params += '&prefix=' + encodeURIComponent(data.prefix);
    params += '&city_filter=' + encodeURIComponent(data.city_filter);
    params += '&state_filter=' + encodeURIComponent(data.state_filter);
    // params += '&max_results=' + encodeURIComponent('5');
    return this.http.get(this.smartyStreetAutocompleteUrl + params);
  }

  autocompletePro(data): Observable<any> {
    let params = this.smartyStreetKeysPro;
    params += '&search=' + encodeURIComponent(data.search);
    params += '&include_only_cities=' + encodeURIComponent(data.include_only_cities);
    params += '&include_only_states=' + encodeURIComponent(data.include_only_states);
    // params += '&max_results=' + encodeURIComponent('5');
    // params += '&include_only_zip_codes=' + encodeURIComponent(data.include_only_zip_codes);
    return this.http.get(this.smartyStreetAutocompleteProUrl + params);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/address-validation.service.ts